/**
 * 密码复杂度校验单源（登录/建号/改密共用）：空白 / 长度 / 字母数字逐项判断，未满足项分行列出。
 * Arco 同一字段只渲染第一条失败规则，拆成多条 rule 会掩盖后面的问题；这里用单条 validator
 * 收集全部失败项并以 ReactNode 多行展示，避免「明明够长却被报缺字母数字」的困惑。
 * 空白是前端额外拦截（后端 ValidatePassword 不校验空白）；空值交给 required，不重复报错。
 */
export const PASSWORD_RULES = [
  {
    validator: (v: any, cb: (msg?: React.ReactNode) => void) => {
      const s = v == null ? '' : String(v);
      if (!s) return cb();
      const errs: string[] = [];
      if (/\s/.test(s)) errs.push('密码不能包含空白字符');
      if (s.length < 8) errs.push('密码至少 8 位');
      if (!(/[A-Za-z]/.test(s) && /\d/.test(s))) errs.push('密码需同时包含字母和数字');
      if (!errs.length) return cb();
      return cb(
        <>
          {errs.map((e) => (
            <div key={e}>{e}</div>
          ))}
        </>,
      );
    },
  },
];

/** 密码规则简述（输入框 placeholder 用） */
export const PASSWORD_RULE_MSG = '至少 8 位，需同时包含字母和数字，且不能包含空格';
